module.exports = __webpack_public_path__ + "static/6-b153d62e621a3e363ee0dccdbea98a8a.jpg";